export function toISODate(date) {
    const tz = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tz).toISOString().split('T')[0];
}

export function formatDateDE(dateStr) {
    if (!dateStr) return "-";
    // Erwartet "YYYY-MM-DD" → robust ohne Zeitzone
    const [y, m, d] = String(dateStr).split("-");
    if (!y || !m || !d) return dateStr; // falls mal anderes Format kommt
    return `${d.padStart(2, "0")}.${m.padStart(2, "0")}.${y}`;
}

const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatCurrency(value) {
    if (value === null || value === undefined) return '—';
    const normalized = typeof value === 'string' ? value.replace(',', '.').trim() : value;
    const numeric = Number.parseFloat(normalized);
    if (!Number.isFinite(numeric)) return '—';
    return currencyFormatter.format(numeric);
}

export function formatDateTimeLocalInput(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    const pad = (num) => String(num).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function normalizeDateTimeInput(value) {
    if (!value) return null;
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    return trimmed.length === 16 ? `${trimmed}:00` : trimmed;
}
